module.exports = __webpack_public_path__ + "img/knus_gallery1.09ecb9d8.jpg";